import React, { Component } from "react";
import F from "../../Functions";
import axios from "axios";
import Pagination from "../../components/pagination";
import DataHandler from "../../utils/DataHandler";
import { Row, Col, Card, Icon, Input, Table, Button, message } from "antd";
import ConfirmationModal from "../../components/confirmation-modal";
import { Translate } from "react-translated";
import { debounceQuery, PERMANENT_LOCKED, TEMPORARY_LOCKED } from "../../utils/Constants";
import { LOCKED_USERS_API_URL } from "../../utils/Api_enums";
import CustomAgGridTable from '../../Common-Table/CustomAgGridTable';
import '../../Common-Table/CustomAgGridTable.css';
import CustomHeader from '../../CommonHeader/CustomHeader';

class LockedUser extends Component {
  state = {
    loading: true,
    users: [],
    page: 1,
    total_pages: 0,
    user: {},
    search: "",
    sortOrders: {}
  };
  componentDidMount = () => {
    this.loadagency()
  };



  loadagency = () => {
    this.loadUsers(1);
  }

  componentDidUpdate = (prevProps) => {
    if (prevProps.location.state !== this.props.location.state) {
      this.loadagency()
    }
  };

  loadUsers = (page = 1) => {
    const { sortOrders } = this.state;
    const searchWord = this.state.search.trim();
    let api = `${LOCKED_USERS_API_URL}?page=${page}`;
    if (searchWord) {
      api += `&search_word=${encodeURIComponent(searchWord)}`;
    }
    const sortField = Object.keys(sortOrders)[0];
    const sortOrder = sortOrders[sortField];
    if (sortField && sortOrder) {
      api += `&sort_by=${sortField}&sort_order=${sortOrder}`;
    }
    this.setState({ loading: true });
    axios.get(api).then((res) => {
      this.setState({
        loading: false,
        users: res.data.locked_users || [],
        page: res.data.page || 1,
        total_pages: res.data.total_pages || 0,
      });
    });
  };


  unlockUser = (user) => {


    this.setState({
      loading: true
    });

    axios
      .put("/api/unlock_user/" + user.id)
      .then((res) => {
        this.setState({
          loading: false
        });

        const response = res.data;

        if (response.success) {
          message.success(response.message);
          this.loadUsers(this.state.page)
        } else {
          message.error(response.error);
        }

      })
      .catch((error) => {
        F.log(error);
        this.setState({
          loading: false
        });
      });
  };

  searchUser = (event) => {
    this.setState({ search: event.target.value }, () => {
      debounceQuery(this.loadUsers.bind(this, 1));
    });
  };

  refreshInfo = () => {

    localStorage.removeItem("agGridColumnState");

    if (this.state.columnApi) {
      this.state.columnApi.resetColumnState();
      this.state.columnApi.resetColumnGroupState();
    }


    this.setState({ search: "", sortOrders: {} }
      , () => {
        this.loadUsers(this.state.page);
      });
  };


  onGridReady = (params) => {
    this.setState({
      gridApi: params.api,
      columnApi: params.columnApi
    });

    const savedState = localStorage.getItem("agGridColumnState");
    if (savedState) {
      params.columnApi.applyColumnState({
        state: JSON.parse(savedState),
        applyOrder: true,
      });
    }
  }

  saveState = (params) => {
    const state = params.columnApi.getColumnState();
    localStorage.setItem("agGridColumnState", JSON.stringify(state));
  }


  handleSort = (field) => {
    this.setState({ loading: true });
    this.setState((prevState) => {
      const currentOrder = prevState.sortOrders[field] || "asc";
      const newOrder = currentOrder === "asc" ? "desc" : "asc";

      return {
        sortOrders: {
          // ...prevState.sortOrders,
          [field]: newOrder,
        },
        currentPage: 1,
      };
    }, () => {
      this.loadUsers(1);
    })
  };


  render() {
    const { loading, users, page, total_pages, sortOrders } = this.state;

    const columnDefs = [
      {
        headerClass: 'custom-ag-header',
        headerName: 'First Name',
        field: 'first_name',
        minWidth: 200,
        flex: 1,
        sortable: true,
        headerComponent: CustomHeader,
        headerComponentParams: (params) => ({
          headers: ['First Name'],
          colDef: params.column.getColDef(),
          columnApi: params.columnApi,
          field: 'first_name',
          sortOrder: sortOrders["first_name"],
          handleSort: this.handleSort,
        }),
        cellRendererFramework: (params) => (
          <div>{params.data.first_name}</div>
        ),
      },
      {
        headerClass: 'custom-ag-header',
        headerName: 'Last Name',
        field: 'last_name',
        minWidth: 200,
        flex: 1,
        sortable: true,
        headerComponent: CustomHeader,
        headerComponentParams: (params) => ({
          headers: ['Last Name'],
          colDef: params.column.getColDef(),
          columnApi: params.columnApi,
          field: 'last_name',
          sortOrder: sortOrders["last_name"],
          handleSort: this.handleSort,
        }),
        cellRendererFramework: (params) => (
          <div>{params.data.last_name}</div>
        ),
      },
      {
        headerClass: 'custom-ag-header',
        headerName: 'Email',
        field: 'email',
        minWidth: 250,
        flex: 1,
        sortable: true,
        headerComponent: CustomHeader,
        headerComponentParams: (params) => ({
          headers: ['Email'],
          colDef: params.column.getColDef(),
          columnApi: params.columnApi,
          field: 'email',
          sortOrder: sortOrders["email"],
          handleSort: this.handleSort,
        }),
        cellRendererFramework: (params) => (
          <div>{params.data.email}</div>
        ),
      },
      {
        headerClass: 'custom-ag-header',
        headerName: 'Lock Status',
        field: 'lock_status',
        minWidth: 200,
        flex: 1,
        sortable: false,
        headerComponent: CustomHeader,
        headerComponentParams: (params) => ({
          headers: ['Lock Status'],
          colDef: params.column.getColDef(),
          columnApi: params.columnApi,
          field: 'lock_status',
        }),
        cellRendererFramework: (params) => (
          <div>
            {params.data.locked ? (
              <span style={{ color: "red" }}>
                <Icon type="lock" style={{ marginRight: 5 }} />
                {PERMANENT_LOCKED}
              </span>
            ) : params.data.temporary_lock ? (
              <span style={{ color: "orange" }}>
                <Icon type="clock-circle" style={{ marginRight: 5 }} />
                {TEMPORARY_LOCKED}
              </span>
            ) : (
              <span style={{ color: "green" }}>
                <Icon type="check-circle" style={{ marginRight: 5 }} />
                Active
              </span>
            )}
          </div>
        )

      },
      {
        headerClass: 'custom-ag-header',
        headerName: 'Action',
        field: 'action',
        minWidth: 180,
        flex: 1,
        sortable: false,
        headerComponent: CustomHeader,
        headerComponentParams: (params) => ({
          headers: ['Action'],
          colDef: params.column.getColDef(),
          columnApi: params.columnApi,
          field: 'action',
        }),
        cellRendererFramework: (params) => (
          <div style={{marginLeft:'-5px'}}>
            <Button
              className="borderRadius-28"
              onClick={() => this.unlockUser(params.data)}
            >
              <Icon type="unlock" /> Unlock User
            </Button>
          </div>
        ),
      },
    ];

    return (
      <div>
        <Card
          type="inner"
          title={
            <div style={{ paddingTop: 7 }}>
              <Icon type="team" style={{ marginRight: 10, color: "#1890ff" }} />
              Locked Users
            </div>
          }
          className="tableCard"
          loading={loading}
          extra={
            <div>
              <Row gutter={16}>
                <Col md={50} span={16}>
                  <Input
                    placeholder="Search Locked User"
                    className="borderRadius-28"
                    onChange={(e) => this.searchUser(e)}
                    value={this.state.search}
                    style={{ width: "100%" }}
                    onPressEnter={() => {
                      this.loadUsers(1);
                    }}
                  />
                  {this.state.search ? (
                    <Icon
                      type="close"
                      onClick={() => this.searchUser({ target: { value: "" } })}
                      className="icon-style"
                    />
                  ) : (
                    <Icon
                      type="search"
                      className="icon-style"
                    />
                  )}
                </Col>
                <Col md={50} span={8}>
                  <Button
                    type="primary"
                    className="bg-164897 borderRadius-28"
                    onClick={this.refreshInfo}
                  >
                    <Icon type="reload" />
                    Refresh
                  </Button>
                </Col>
              </Row>
            </div>
          }
        >
          <CustomAgGridTable
            onGridReady={this.onGridReady}
            onColumnMoved={this.saveState}
            onSortChanged={this.saveState}
            onFilterChanged={this.saveState}
            rowDatas={users}
            columnDefss={columnDefs}
          />
          <Pagination
            className="pagination-container cpagination"
            current_page={page}
            total_pages={total_pages}
            onClick={(page) => {
              this.loadUsers(page);
            }}
          />
        </Card>
      </div>
    );
  }
}

export default LockedUser;



// WEBPACK FOOTER //
// ./src/scenes/ManageUsers/locked-users.js